import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { createLazyOrchestrator } from 'owa-bundling';
import { goToToday, refreshDayPicker } from 'owa-calendar-module-commanding';
import { updateDateRange, updateSelectedDate } from 'owa-calendar-surface';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { loadItemsOnDateRangeChange } from 'owa-calendar-surface-view-store';
import { DisplayDate, today } from 'owa-datetime';
import { areDateRangesEqual, createDateRangeFromType, DateRange } from 'owa-datetime-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { navigateCalendarAssetToDate } from 'owa-timestream-asset-sdk-actions';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Ideally we can find a way to eventually differentiate module concerns (e.g. selected date)
// from concerns that are specific to traditional surface view, but right now we need to
// continue overloading the calendar surface store to also track some module concerns
// and update them regardless of current view context in order to keep features like
// left-nav mini month working correctly

export const goToTodayOrchestrator = createLazyOrchestrator(goToToday, 'goToToday_CLONE', () => {
    const currentDay = today();
    const surfaceStore = getSurfaceStore();

    const newDateRange = getTodayRange(
        surfaceStore.dateRangeType,
        currentDay,
        surfaceStore.userOptions.workDays,
        getNumDaysInDayRange()
    );

    const sameDateRange = areDateRangesEqual(newDateRange, surfaceStore.dateRange);
    updateDateRange(newDateRange, surfaceStore);
    updateSelectedDate(currentDay, surfaceStore);

    refreshDayPicker();

    navigateCalendarAssetToDate(currentDay);

    if (!sameDateRange) {
        loadItemsOnDateRangeChange(newDateRange, surfaceStore.dateRangeType);
    }
});

function getTodayRange(
    dateRangeType: DateRangeType,
    currentDay: DisplayDate,
    workDays: number[],
    numOfDaysInDayRange?: number
): DateRange {
    const firstDayOfWeek = getUserConfiguration().UserOptions.WeekStartDay;
    return createDateRangeFromType(
        dateRangeType,
        currentDay,
        firstDayOfWeek,
        workDays,
        numOfDaysInDayRange
    );
}
